import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const exportOffers = async (body) => {
  try {
    const response = await axiosInstance.post('/offers/export/', body);
    if (response.status === 204 || !response.data?.file_path) {
      return { async: true };
    }
    return response.data;
  } catch (error) {
    console.error('Export Offers API error:', error);
    throw error;
  }
};

export const useExportOffers = (options = {}) => {
  const {
    onSuccess: externalOnSuccess,
    onError: externalOnError,
    ...mutationOptions
  } = options;

  const mutation = useMutation({
    ...mutationOptions,
    mutationFn: exportOffers,
    onSuccess: (data, variables) => {
      externalOnSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      externalOnError?.(error, variables);
    },
  });

  return {
    exportOffers: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
